import { useEffect } from "react";
import { Button, Container, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { FiArrowRight, FiCamera, FiCheckCircle, FiClock, FiMic } from "react-icons/fi";

const ThankYou = () => {
    const { state } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!state) {
            window.location.href = "/";
        }
    }, [state]);

    if (!state) {
        return (
            <div className="thank-container">
                <Spinner />
            </div>
        );
    }

    const isTalentForm = state?.key === "talent-form" || state?.from === "talent-form";
    const canStartInterview = isTalentForm && state?.jobId && state?.outsourceId;

    const handleStartInterview = () => {
        navigate(`/interview/${state.jobId}`, {
            state: {
                jobId: state.jobId,
                outsourceId: state.outsourceId,
                applicationId: state.applicationId || null,
            }
        });
    };

    return (
        <div className="thank-container">
            <Container>
                <div className="thank-shell text-center">
                    <div className="thank-shell__eyebrow">
                        <FiCheckCircle />
                        <span>{isTalentForm ? "Pendaftaran berhasil dikirim" : "Pesan berhasil diterima"}</span>
                    </div>

                    <div className="thank-shell__heading text-brand">
                        {isTalentForm ? (
                            <>Terima Kasih Telah Mendaftar<br />Sebagai Talent</>
                        ) : (
                            "Terima Kasih Telah Menghubungi Kami"
                        )}
                    </div>

                    <div className="thank-shell__subtitle">
                        {isTalentForm
                            ? "Lamaran Anda berhasil dikirim. Langkah berikutnya tinggal selesaikan AI Interview untuk melanjutkan proses seleksi."
                            : "Pesan Anda sudah kami terima. Tim kami akan meninjau dan segera menghubungi Anda."}
                    </div>

                    {canStartInterview && (
                        <div className="thank-next-step-card">
                            <div className="thank-next-step-card__badge">Langkah berikutnya</div>
                            <div className="thank-next-step-card__header">
                                <div className="thank-next-step-card__icon">
                                    <FiMic />
                                </div>
                                <div className="thank-next-step-card__copy">
                                    <div className="thank-next-step-card__title">Selesaikan AI Interview</div>
                                    <p className="thank-next-step-card__description">
                                        AI Interview wajib diselesaikan untuk melanjutkan proses seleksi. Siapkan perangkat Anda, lalu mulai sesi saat sudah siap.
                                    </p>
                                </div>
                            </div>

                            <div className="thank-next-step-card__meta">
                                <div className="thank-next-step-card__meta-item">
                                    <FiClock />
                                    <span>Estimasi 15-20 menit</span>
                                </div>
                                <div className="thank-next-step-card__meta-item">
                                    <FiCamera />
                                    <span>Kamera dan mikrofon aktif</span>
                                </div>
                                <div className="thank-next-step-card__meta-item">
                                    <FiCheckCircle />
                                    <span>Wajib untuk lanjut seleksi</span>
                                </div>
                            </div>

                            <Button
                                variant="brand"
                                className="thank-next-step-card__cta"
                                onClick={handleStartInterview}
                            >
                                <strong>Mulai AI Interview</strong>
                                <FiArrowRight />
                            </Button>
                        </div>
                    )}

                    <a href="/">
                        <Button variant="outline-brand" className="thank-shell__secondary-cta">
                            <strong>Kembali Ke Beranda</strong>
                        </Button>
                    </a>
                </div>
            </Container>
        </div>
    );
};

export default ThankYou;
